import type { LinkColourScheme } from "./types"

export const BASE_CLASSES =
  "transition-all underline outline-none font-medium box-border flex items-center gap-2 justify-center w-fit"

export const BASE_CLASSES_MD = "text-base/6"
export const BASE_CLASSES_SM = "text-sm/4"
export const BASE_CLASSES_DISABLED = "cursor-not-allowed"

export const COLOUR_SCHEME: LinkColourScheme = {
  primary: "text-primary-base",
  gray: "text-gray-400",
}

export const COLOUR_SCHEME_FOCUS: LinkColourScheme = {
  primary:
    "focus-visible:text-primary-darken-100 focus-visible:outline focus-visible:outline-black",
  gray: "focus-visible:text-black focus-visible:outline focus-visible:outline-black",
}

export const COLOUR_SCHEME_HOVER: LinkColourScheme = {
  primary: "hover:text-primary-darken-100",
  gray: "hover:text-black",
}

export const COLOUR_SCHEME_DISABLED: LinkColourScheme = {
  primary: "text-primary-lighten-50",
  gray: "text-gray-300",
}
